import type { components } from "@/api-schema";
import imageCompression from "browser-image-compression";
import imageCompressionWorkerUrl from "browser-image-compression/dist/browser-image-compression.js?url";
import { blobAsBase64 } from "./blob-as-base64";

type Base64File = components["schemas"]["Base64FileDto"];

export async function encodeFile(file: File): Promise<Base64File> {
  const dataUrl = await blobAsBase64(file);
  return {
    name: file.name,
    mimeType: file.type || "application/octet-stream",
    data: dataUrl.slice(dataUrl.indexOf(",") + 1),
  };
}

export async function encodeLogoRequest<T extends { logo?: File | null }>(
  body: T,
): Promise<Omit<T, "logo"> & { logo?: Base64File | null }> {
  const { logo, ...data } = body;
  if (logo === undefined || logo === null) {
    return logo === null ? { ...data, logo: null } : data;
  }

  const compressedLogo =
    logo.type === "image/svg+xml"
      ? logo
      : await imageCompression(logo, {
          maxSizeMB: 0.15,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          libURL: new URL(imageCompressionWorkerUrl, window.location.href).href,
          preserveExif: false,
        });

  return { ...data, logo: await encodeFile(compressedLogo) };
}
